import { vuexOidcCreateStoreModule } from 'vuex-oidc'
import {WebStorageStateStore} from 'oidc-client'
import Vuex from 'vuex'
import Vue from 'vue'


export const oidcSettings = {
      // "acr_values" : "tenant:MasterTenant ",//+ tenant,
      ///****************Prod****************/
      // "authority": 'https://apiv2.trackervigil.com/identity', 
      // "client_id":"netlify.identity.app",
      // "client_secret":"e649a3e9-7be3-461e-bab4-742b48eed38e",      
      ///****************Prod****************/
      ///****************Localhost****************/  
      // "authority": 'https://localhost:5002', 
      // "client_id": "localhost.app",
      // "client_secret":"ea6a4bce-64f9-4d48-b4c0-fd79f7f2df95",
      ///****************Localhost****************/
      ///****************Netlify****************/
      // Both ND and TT use the same client credentials
      //  "authority": 'https://api.vts-dev.xyz/identity/', 
      //  "authority":"https://idraft-api-qa.intertek.com/identity/",
      "authority": 'https://api.livetrak.in/identity', 
      //  "authority": 'https://paidentity.azurewebsites.net', 
      // "authority": 'https://idraft-identity-demo.azurewebsites.net/', 
      //  "authority":"https://api.trackervigil.in/identity",
      // "authority":"https://api.novigodemo.com/identity",
      // "authority":'https://api.testtracker.xyz/identity',
      // "authority":"https://idraft-api-dev.intertek.com/",
      "client_id":"netlify.identity.app",
      "client_secret":"3d6eaeb4-c61c-423e-bdfb-6dfac53d81d1",
      // "client_secret":"2bdyD6d63saW",
      ///****************Netlify****************/
      //************Identity Portal 88-lt  *************/
      // "authority":"https://api.livetrak.in/identity/",
      // "client_id": "identity.lt.app", 
      // "client_secret": "a2cc8529-889a-48b0-af66-a145423ed572",
      // "authority":"http://projectallocationidentity.novigodemo.com",
      // "authority":"http://identityapi.novigodemo.com",
      //************Identity Portal 88  *************/
      //************Identity Portal 88  *************/
      // "client_id": "novigoidentityportal.app", 
      // "client_secret": "a2cc8529-889a-48b0-af66-a145423ed572",
      // "authority":"http://project-allocation.novigodemo.com/identity",
      // "authority":"http://identityportal.novigodemo.com/identity",
      //************Identity Portal 88  *************/
      //************TestTracker*************/
      // "client_id": "novigoidentityportal.app", 
      // "client_secret": "a2cc8529-889a-48b0-af66-a145423ed572",
      // "authority":'https://api.testtracker.xyz/identity',
      //************Identity Portal 88  *************/
      //"authority": 'https://nvg-identityserver.conveyor.cloud/', 
      //"client_id":"vts-mobile.app",
      // "client_id":"new.client.app",
      //"authority":"https://api.novigodemo.com",
      // "authority":"https://api.vts-dev.xyz/identity",
      //"redirect_uri": "http://identitymanager.novigodemo.com/callback",
      "redirect_uri": window.location.origin+"/callback",//window.location.origin+"/callback", //"http://localhost:8080/callback",
      "client_name":"Vue JS APP for novigi portal",
      "grant_type": "authorization_code",
      "response_type": "code",
      "scope": "openid profile offline_access",
      //"post_logout_redirect_uri": "http://identitymanager.novigodemo.com/logoutSuccess",
      //"silent_redirect_uri": 'http://identitymanager.novigodemo.com/silent-renew-oidc',//'http://identity.novigodemo.com/silent-renew-oidc',
      "post_logout_redirect_uri": window.location.origin+"/logoutSuccess",
      "silent_redirect_uri": window.location.origin+'/silent-renew-oidc',//'http://identity.novigodemo.com/silent-renew-oidc',
      "automaticSilentRenew": true,
  }
  Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    oidcStore: vuexOidcCreateStoreModule(
      oidcSettings,
      // NOTE: If you do not want to use localStorage for tokens, in stead of just passing oidcSettings, you can
      // spread your oidcSettings and define a userStore of your choice
      // {
      //   ...oidcSettings,
      //   userStore: new WebStorageStateStore({ store: window.sessionStorage })
      // },
      // Optional OIDC store settings
      // Optional OIDC event listeners
      {
        userLoaded: (user) => console.log('OIDC user is loaded:', user),
        userUnloaded: () => console.log('OIDC user is unloaded'),
        accessTokenExpiring: () => console.log('Access token will expire'),
        accessTokenExpired: () => console.log('Access token did expire'),
        silentRenewError: () => console.log('OIDC user is unloaded'),
        userSignedOut: () => console.log('OIDC user is signed out'),
        oidcError: (payload) => console.log('OIDC error', payload),
        automaticSilentRenewError: (payload) => console.log('OIDC automaticSilentRenewError', payload)
      }
    )
  }
})